import { useNotifications } from '@toolpad/core';
import React, { useCallback } from 'react';

import { CustomToast, type ToastOptions } from '../../../components/index.ts';

export const useAppNotify = () => {
  const notify = useNotifications();

  const showToast = useCallback(
    (opts: ToastOptions) => {
      const { title, message, severity = 'success', actions, autoHideDuration = 5000 } = opts;

      notify.show(
        <CustomToast
          title={title}
          message={message}
          actions={actions}
          duration={autoHideDuration}
          notifyKey={message}
          severity={severity}
        />,
        {
          key: message,
          severity,
          autoHideDuration,
        }
      );
    },
    [notify]
  );

  const notifyError = useCallback(
    (message?: string, options?: Omit<ToastOptions, 'message'>) => {
      if (!message) return;

      showToast({
        ...options,
        title: options?.title || 'Error',
        message,
        severity: 'error',
      });
    },
    [showToast]
  );

  const notifySuccess = useCallback(
    (message?: string, options?: Omit<ToastOptions, 'message'>) => {
      if (!message) return;

      showToast({
        ...options,
        title: options?.title || 'Success',
        message,
        severity: 'success',
      });
    },
    [showToast]
  );

  return {
    showNotification: showToast,
    notifyError,
    notifySuccess,
  };
};
